const env = import.meta.env;
export const COOKIEHUB_GLOBAL_VAR = 'cookiehub';
export const COOKIEHUB_SCRIPT_ID = 'cookiehub-script';

const getDomainWithoutSubdomain = (url: string) => {
  const urlParts = url.split('.');

  return urlParts
    .slice(0)
    .slice(-(urlParts.length === 4 ? 3 : 2))
    .join('.');
};

const prod = {
  apiUrl: `https://emporium-backend.${getDomainWithoutSubdomain(location.host)}/api`,
  workflowUrl: `https://emporium-workflow.${getDomainWithoutSubdomain(location.host)}`,
};

const dev = {
  apiUrl: `https://emporium-backend.dev.opyn.eu/api`,
  workflowUrl: `https://emporium-workflow.dev.opyn.eu`,
};

const IS_DEV_ENV = env.MODE === 'development';

const SERVER_BASE_URL = IS_DEV_ENV ? dev.apiUrl : prod.apiUrl;
const WORKFLOW_BASE_URL = IS_DEV_ENV ? dev.workflowUrl : prod.workflowUrl;

if (!IS_DEV_ENV) {
  console.error = () => {};
  console.warn = () => {};
}

const IS_PRODUCTION =
  !IS_DEV_ENV &&
  !location.host.includes('.dev.') &&
  !location.host.includes('.test.');

const GET_ENV_NAME = (): string => {
  switch (true) {
    case IS_DEV_ENV:
      return 'local';
    case location.host.includes('.dev.'):
      return 'dev';
    case location.host.includes('.test.'):
      return 'test';
    default:
      return 'production';
  }
};

export {
  SERVER_BASE_URL,
  IS_DEV_ENV,
  WORKFLOW_BASE_URL,
  IS_PRODUCTION,
  GET_ENV_NAME,
};
//prod trigger
